import { LinkButton, Responsive } from '@cian/ui-kit';
import { IconActionArrowUpRight16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackOpenContactsClick, trackShowPhoneClick } from '../../../analytics/promos';

import { useApplicationContext } from '../../../utils/applicationContext';
import { getCianMortgagePromoUrl } from '../../../utils/config';
import { newbuildingIdSelector, gaLabelSelector } from '../../../selectors';
import { EPromoType, IPromoInfo } from '../../../types/newbuilding/promoInfo';
import { CallButton } from '../../CallButton';

export interface IActionButtonContainerProps {
  hasContacts: boolean;
  onMortgageClick?(): void;
  promo: IPromoInfo;
}

export const ActionButtonContainer: React.FC<IActionButtonContainerProps> = ({
  hasContacts,
  onMortgageClick,
  promo,
}) => {
  const { config } = useApplicationContext();
  const cianMortgageLink = getCianMortgagePromoUrl(config);

  const gaLabel = useSelector(gaLabelSelector);
  const newbuildingId = useSelector(newbuildingIdSelector);

  const trackShowPhone = React.useCallback(() => {
    trackShowPhoneClick(gaLabel, promo, newbuildingId);
  }, [gaLabel, promo, newbuildingId]);

  const trackOpenContacts = React.useCallback(() => {
    trackOpenContactsClick(gaLabel, promo.uniquePromoId, newbuildingId);
  }, [gaLabel, promo, newbuildingId]);

  if (promo.promoType === EPromoType.CianMortgage) {
    return (
      <>
        <Responsive desktop>
          <LinkButton href={cianMortgageLink} onClick={onMortgageClick} theme="fill_secondary" size="M" fullWidth>
            Получить ипотеку онлайн
          </LinkButton>
        </Responsive>
        <Responsive tablet phone>
          <LinkButton
            beforeIcon={<IconActionArrowUpRight16 color="icon-main-default" />}
            href={cianMortgageLink}
            onClick={onMortgageClick}
            theme="fill_white_primary"
            size="M"
          ></LinkButton>
        </Responsive>
      </>
    );
  }

  if (!hasContacts) {
    return null;
  }

  return (
    <Responsive desktop>
      <CallButton
        onOpenContactsClick={trackOpenContacts}
        onShowPhoneClick={trackShowPhone}
        placeType="Open_jk_mortgage"
      />
    </Responsive>
  );
};
